import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';

// Composants
import { BaseComponent } from 'src/app/@shared/components/abstract/base.component';

// Modèles
import { Conversation } from 'src/app/@shared/models/messaging/conversation.model';

@Component({
	selector: 'app-conversations-list',
	imports: [
		CommonModule,
		TooltipModule,
	],
	templateUrl: './conversations-list.component.html',
	styleUrl: './conversations-list.component.scss'
})
export class ConversationsListComponent extends BaseComponent {

	/*----------------------------------------------------------------------------------------
	 * Gestion de la vue
	 ----------------------------------------------------------------------------------------*/

	@Output()
	public conversationSelected: EventEmitter<Conversation> = new EventEmitter<Conversation>();

	/*----------------------------------------------------------------------------------------
	 * Données
	 ----------------------------------------------------------------------------------------*/

	private _conversations: Conversation[] = [];
	public get conversations(): Conversation[] {
		return this._conversations;
	}
	@Input()
	public set conversations(value: Conversation[]) {
		let emptyArray: Conversation[] = [];
		this._conversations = emptyArray.concat(value);
	}
	@Input()
	public selectedConversation: Conversation | null = null;

	/*----------------------------------------------------------------------------------------
	 * Accesseurs
	 ----------------------------------------------------------------------------------------*/



	/*----------------------------------------------------------------------------------------
	 * Méthodes publiques
	 ----------------------------------------------------------------------------------------*/

	public selectConversation(conversation: Conversation): void {
		this.conversationSelected.emit(conversation);
	}

	/*----------------------------------------------------------------------------------------
	 * Méthodes protégées
	 ----------------------------------------------------------------------------------------*/



	/*----------------------------------------------------------------------------------------
	 * Méthodes privées
	 ----------------------------------------------------------------------------------------*/

}
